// *** STEPS TO IMPLEMENT ON SITE ***
// Add 'js-validateForm' class to each form
// Make sure the form submission button is a button with type 'submit'

// *** MULTISTEP FORM REQUIREMENTS ***
// Final submit button must be a button with type 'submit'
// Any buttons that change the form step must be labeled with the 'data-stepchange' attribute
// NOTE: the data attr had to be changed from data-step-change to data-stepchange. The hyphen was causing issues
// Each step of the form must be contained in a div with the 'data-step' attribute

//vars to control ajax eror messages and bugsnag

document.addEventListener("DOMContentLoaded", function() {



var errorNum = 0;
var errorMax = 2;
var trustedFormLoaded = false;
let ajaxValidated;

//handle form submission to formparser with ajax

async function ltsubmit(e) {
    var form = e.target.closest(".js-validateForm");

    if (form.dataset.onSubmit === "noSubmit") {
        return;
    }

    if (form.dataset.onsubmitfn) {
        e.preventDefault();
        handleOnSubmitFunction(form.dataset.onsubmitfn, form);
    } else if (e.target.action.indexOf("/FormParser.php") >= 0) {
        // Prevent form from submitting

        const tempConstraints = {
            full_name: {
                presence: {
                    message: "^Name is required"
                },
                length: {
                    minimum: 2,
                    message: "^Name must be at least 2 characters"
                },
                format: {
                    pattern: "[a-z A-Z]+",
                    message: "^Name can only contain letters"
                }
            },
            effect: {
                presence: {
                    message: "^Select an option"
                }
            },
            zip_code: {
                presence: {
                    message: "^Zip code is required"
                },
                format: {
                    pattern: {},
                    message: "^Zip code is invalid"
                }
            },
            email: {
                presence: {
                    message: "^Email is required"
                },
                email: {
                    message: "^Email is invalid"
                },
                ajaxValidation: {
                    message: "^Please provide a valid email address"
                }
            },
            phone: {
                presence: {
                    message: "^Phone number is required"
                },
                ajaxValidation: {
                    message: "^Please provide a valid phone number"
                },
                format: {
                    pattern: {},
                    message: "^Phone must be a valid US Phone Number"
                }
            },
            preferred_contact: {},
            comments: {},
            requested_service: {}
        };

        e.preventDefault();
        ajaxValidation(form);
    }
}

//add submit event listener to forms
var ltforms = document.querySelectorAll(".js-validateForm");
for (var i = 0; i < ltforms.length; i++) {
    ltforms[i].addEventListener("submit", ltsubmit, false);
}

//rule to trim leading and trailing spaces from form inputs. This can make html5 validation confusing if someone has a leading space and is breaking the pattern
var trimInputs = function(e) {
    e.target.value = e.target.value.trim();
};

//add input blur event listener to forms
var formInputs = document.querySelectorAll(
    ".js-validateForm input.c-form__control"
);
for (var i = 0; i < formInputs.length; i++) {
    formInputs[i].addEventListener("blur", trimInputs, false);
}

//init trusted forms, will load once an input has been modified
var trustForm = function(e) {
    if (trustedFormLoaded == false) {
        // loadTrustedForm();   <----- Questions About This!!!
        trustedFormLoaded = true;
        removeTrustFormListener();
        //fix jornaya leadid not being on all forms that need it
        if (document.querySelector('input[name="universal_leadid"][value]')) {
            var leadID = document.querySelector(
                'input[name="universal_leadid"][value]'
            ).value;
            var leadidFields = document.querySelectorAll(
                'input[name="universal_leadid"]'
            );
            for (var i = 0; i < leadidFields.length; i++) {
                leadidFields[i].value = leadID;
            }
        }
    }
};

var trustedForm = document.querySelectorAll(
    ".js-validateForm select, .js-validateForm input"
);
for (var i = 0; i < trustedForm.length; i++) {
    trustedForm[i].addEventListener("focusin", trustForm, false);
}

//stop listening for trustedform to load
var removeTrustFormListener = function(e) {
    for (var i = 0; i < trustedForm.length; i++) {
        trustedForm[i].removeEventListener("focusin", trustForm, false);
    }
};

var check_f_name = function(e) {
    var form = e.target.closest(".js-validateForm");
    var f_name = form.querySelector("input[name=f_name]");
    if (f_name && f_name.value.length == 0) {
        f_name.required = "";
    }
};

var submits = document.querySelectorAll(".js-validateForm button[type=submit]");
for (var i = 0; i < submits.length; i++) {
    submits[i].addEventListener("click", check_f_name, false);
}

function handleStepCompleteFunction(functionName, form) {
    if (
        typeof window[functionName] !== "undefined" &&
        typeof window[functionName] === "function"
    ) {
        window[functionName](form);
    } else {
        console.warn("Function for step complete missing.");
    }
}
function handleOnSubmitFunction(functionName, form) {
    if (
        typeof window[functionName] !== "undefined" &&
        typeof window[functionName] === "function"
    ) {
        window[functionName](form);
    } else {
        console.warn("Function for submit missing.");
    }
}

//change form validation when country field changes, still in progress
/*document.addEventListener('change', function (e) {

    if (e.target.tagName !== 'SELECT' ||  e.target.name !== "country" ) return;

    console.log(e);

    var form = e.target.closest('.js-validateForm');
    var country = e.target.value.toLowerCase();

    if (form && form.querySelector('input[name=zip_code]')){
        var zip = form.querySelector('input[name=zip_code]');
        //console.log(country);
        if (country==="usa"){
            zip.setAttribute("title","Five digit zip code. Example: 90210");
            zip.setAttribute("pattern","\\d{5}");
        } else if (country==="canada") {
            zip.setAttribute("title","Six character postal code. Example: A1A A1A");
            zip.setAttribute("pattern","[^\\s]{3} ?[^\\s]{3}");
        } 
    }  

}, false);*/

//conditional form first step
var radios = document.querySelectorAll(".js-conditional-field input");

for (i = 0; i < radios.length; i++) {
    radios[i].addEventListener(
        "change",
        function(e) {
            var form = e.target.closest(".js-validateForm");
            var dynamicFields = form.querySelectorAll("[data-showvalue]");
            for (j = 0; j < dynamicFields.length; j++) {
                if (dynamicFields[j].dataset.showvalue === e.target.value) {
                    var parent = dynamicFields[j].parentNode;
                    if (
                        dynamicFields[j].parentNode.className.includes(
                            "c-form__group"
                        )
                    ) {
                        dynamicFields[j].parentNode.style.display = "";
                    }
                    dynamicFields[j].disabled = false;
                } else {
                    if (
                        dynamicFields[j].parentNode.className.includes(
                            "c-form__group"
                        )
                    ) {
                        dynamicFields[j].parentNode.style.display = "none";
                    }
                    dynamicFields[j].disabled = true;
                }
            }
            //if there is a data-requestedservice, change the value of the hidden field
            if (e.target.dataset.requestedservice) {
                form.querySelector("[name=requested_service]").value =
                    e.target.dataset.requestedservice;
            }
            if (e.target.dataset.typage) {
                form.querySelector("[name=ty_page]").value =
                    e.target.dataset.typage;
            }
        },
        false
    );
}



function isLocalStorageAvailable(storage) {
    try {
      const test = 'test';
      storage.setItem(test, test);
      storage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

function saveUserInfoToLocal(fullName, email, diagnosis, phoneNumber, requestedService) {
    if (isLocalStorageAvailable(localStorage)) {
        localStorage.setItem("fullName", fullName);
        localStorage.setItem("email", email);
        localStorage.setItem("diagnosis", diagnosis);
        localStorage.setItem("phoneNumber", phoneNumber);
        localStorage.setItem("requested_service", requestedService);
    } else {
        console.warn("No local storage available");
    }
}

function sendFormData(form) {
    form.classList.add("c-form--submitting");
    form.getElementsByClassName("c-form__submit")[0].disabled = true;
    form.getElementsByClassName("c-form__submit-error")[0].style.display =
        "none";
    form.getElementsByClassName("c-form__network-error")[0].style.display =
        "none";

    var XHR = new XMLHttpRequest();

    // Bind the FormData object and the form element
    var FD = new FormData(form);

    saveUserInfoToLocal(FD.get("full_name"), FD.get("email"), FD.get("effect"), FD.get("phone"), FD.get("requested_service"));
    FD.append("ajax", 1); //tell formparser this is an ajax request

    // Define what happens on successful data submission
    XHR.addEventListener("load", function(e) {
        //if the form parser returns any status code, then it loaded

        if (XHR.status === 200) {
            //we are only considering a 200 status to be successful
            var tyParams = [];
            var tyPage = "/thank-you/";

            try {
                if (typeof mixpanel === "object") {
                    mixpanel.track("Form Submit Success", {});
                }
            } catch (e) {
                Bugsnag.notify(
                    new Error(
                        "Mixpanel Form Submit Success Event Unsuccessful"
                    ),
                    function(e) {}
                );
            }

            if (typeof formSuccessEvent === "function") {
                formSuccessEvent(form);
            }

            if (
                form.querySelector("input[name=ty_page]") &&
                form.querySelector("input[name=ty_page]").value
            )
                tyPage = form.querySelector("input[name=ty_page]").value;
            // if (form.querySelector('input[name=full_name]') && form.querySelector('input[name=full_name]').value){
            //     sessionStorage.setItem('tyname', form.querySelector('input[name=full_name]').value.split(" ")[0]);
            // }
            //set sessionstorage for parasol forms
            if (
                form.querySelector("input[name=universal_leadid]") &&
                form.querySelector("input[name=universal_leadid]").value
            ) {
                sessionStorage.setItem("typara", 1);
            }
            //Parasol partner campiagn id will need to go here if we need to use call center logic
            //if (form.querySelector('input[name=c_id]') && form.querySelector('input[name=c_id]').value == 99)tyParams.push("jaccept=1");//add utm param to thank you page to load jornaya script
            //values used by Asbestos
            //if (form.querySelector('input[name=ga_form_name]') && form.querySelector('input[name=ga_form_name]').value)tyParams.push("content="+form.querySelector('input[name=ga_form_name]').value.replace(" ","-"));
            /*if (form.querySelector('select[name=effect] :checked') && form.querySelector('select[name=effect] :checked').value == "Mesothelioma")tyParams.push('diagnosis=mesothelioma');
            if (form.querySelector('input[name=full_name]') && form.querySelector('input[name=full_name]').value)tyParams.push("first_name="+form.querySelector('input[name=full_name]').value.split(" ")[0]);
            if (form.querySelector('input[name=ty_page_mod]') && form.querySelector('input[name=ty_page_mod]').value)tyParams.push("modifier="+form.querySelector('input[name=ty_page_mod]').value);
            if (form.querySelector('select[name=ccpa_type] :checked') && form.querySelector('select[name=ccpa_type] :checked').value)tyParams.push("ccpa_ty=true");*/
            //var tyPage = "/thank-you/";//we will eventually need to check for a different thank you page link
            if (form.dataset.filedownload) {
                //hide the parent wrapper of the form and show the js thank you div
                form.parentElement.style.display = "none";
                document.querySelector(".js-thankyou").style.display = "block";
                //if there is a download link in the thank you with correct id, download it
                if (document.getElementById("formDownloadLink")) {
                    document.getElementById("formDownloadLink").click();
                }
            } else if (tyParams.length > 0) {
                form.action = "";
                form.submit(); //submit form for jornaya
                window.location.href = tyPage + "?" + tyParams.join("&");
            } else {
                form.action = "";
                form.submit(); //submit form for jornaya
                window.location.href = tyPage;
            }
        } else {
            sumbitError(form, XHR.status);
        }
    });

    // Define what happens in case of error
    XHR.addEventListener("error", function(e) {
        sumbitError(form, "XMLHttpRequest event error");
    });

    // Set up our request
    XHR.open("POST", form.action); //we are going to use the form action to send

    //try to catch any errors with mixpanel, but continue to execute
    try {
        if (typeof mixpanel === "object") {
            if (FD.entries())
                mixpanel.track(
                    "Form Submit Attempt",
                    Object.fromEntries(FD.entries())
                ); //this should send all form fields to mixpanel
            if (FD.get("full_name"))
                mixpanel.people.set({ $name: FD.get("full_name") });
            if (FD.get("email"))
                mixpanel.people.set({ $email: FD.get("email") });
            if (FD.get("phone"))
                mixpanel.people.set({ $phone: FD.get("phone") });
        }
    } catch (e) {
        Bugsnag.notify(
            new Error("Mixpanel Form Submit Attempt Event Unsuccessful"),
            function(e) {}
        );
    }

    // The data sent is what the user provided in the form
    XHR.send(FD);
}

function sumbitError(form, status) {
    form.classList.remove("c-form--submitting");
    form.getElementsByClassName("c-form__submit")[0].disabled = false;

    try {
        if (typeof mixpanel === "object") {
            mixpanel.track("Form Submit Error", { count: errorNum + 1 });
        }
    } catch (e) {
        Bugsnag.notify(
            new Error("Mixpanel Form Submit Error Event Unsuccessful"),
            function(e) {}
        );
    }

    if (errorNum < errorMax) {
        form.getElementsByClassName("c-form__submit-error")[0].style.display =
            "block";
        Bugsnag.notify(new Error("form ajax network parser error"), function(
            e
        ) {
            e.severity = "error";
            e.context = "form-ajax-error";
            e.addMetadata("submit-attempts", { count: errorNum + 1 }),
                e.addMetadata("xmlstatus", { code: status });
        });
    } else {
        form.classList.add("c-form--disabled");
        form.getElementsByClassName("c-form__network-error")[0].style.display =
            "block";
        Bugsnag.notify(
            new Error("form ajax network parser error disabled"),
            function(e) {
                e.severity = "error";
                e.context = "form-ajax-error-disabled";
                e.addMetadata("submit-attempts", { count: errorNum + 1 }),
                    e.addMetadata("xmlstatus", { code: status });
            }
        );
    }
    errorNum++;
}

//form step change
var formStepChange = function(e) {
    var form = e.target.closest(".js-validateForm");
    if (!form) return; //exit function if this isn't a standard form

    e.preventDefault();
    targetStepNum = e.target.closest("[data-stepchange]").dataset.stepchange;
    var currentStep = form.querySelector("fieldset.is-active");
    var currentStepNum = currentStep.dataset.step;

    if (!targetStepNum || !currentStep || currentStepNum === targetStepNum){
        return;
    }

    var targetStep = form.querySelector(
        'fieldset[data-step="' + targetStepNum + '"]'
    );

    if (targetStepNum > currentStepNum) {
        //validate only going forward in steps

        //var stepInputs = currentStep.getElementsByClassName('c-form__control');
        var stepInputs = currentStep.querySelectorAll(
            "input:not([type=hidden]):not([name=f_name]):not([disabled]), .c-form__control:not([name=f_name]):not([disabled])"
        ); //loop through all inputs that are not hidden and not hp

        if (stepInputs.length == 0)
            navigateToStep(form, currentStep, targetStep, targetStepNum); //this allows a form step with no questions to navigate to the next step
        for (i = 0; i < stepInputs.length; i++) {
            stepInputs[i].value = stepInputs[i].value.trim(); //trim out any leading or trailing whitespace
            if (stepInputs[i].checkValidity() !== true) {
                if (
                    typeof document.createElement("input").reportValidity ==
                    "function"
                ) {
                    stepInputs[i].reportValidity();
                } else {
                    //temp ie11, this will force a submit button click which should throw the validity error
                    form.getElementsByClassName("c-form__submit")[0].click();
                }
                break;
            } else if (i === stepInputs.length - 1) {
                //run stepcomplete function here
                if (typeof formStepSuccessEvent === "function") {
                    if (form.querySelectorAll('.c-form__steps').length) {
                        formStepSuccessEvent( form );
                    }
                }

                if (typeof formStepSubmitEvent === "function") {
                    formStepSubmitEvent(form);
                }

                checkCountryOrigin(form); //check if country of origin is US or not
                navigateToStep(form, currentStep, targetStep, targetStepNum);
            }
        }
    } else {
        navigateToStep(form, currentStep, targetStep, targetStepNum);
    }
};

var nextStepButtons = document.querySelectorAll("[data-stepchange]");

for (var i = 0; i < nextStepButtons.length; i++) {
    nextStepButtons[i].addEventListener("click", formStepChange, false);
}

var phoneMasks = document.getElementsByName("phone");
for (var i = 0; i < phoneMasks.length; i++) {
    phoneMasks[i].addEventListener('input', formatPhoneNumber);
}

function formatPhoneNumber(e) {
    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

function navigateToStep(form, currentStep, targetStep, targetStepNum) {
    form.classList.add("c-form--submitting");
    form.getElementsByClassName("c-form__submit")[0].disabled = true;

    var activeNav = form.querySelector('.c-form__nav-button[data-stepchange="'+currentStep.dataset.step+'"]');
    var targetNav = form.querySelector('.c-form__nav-button[data-stepchange="'+targetStepNum+'"]');

    setTimeout(function() {
        currentStep.style.display = "none";
        currentStep.classList.remove("is-active");

        targetStep.style.display = "block";
        targetStep.classList.add("is-active");

        activeNav.classList.remove("is-active");
        targetNav.classList.add("is-active");

        form.classList.remove("c-form--submitting");
        form.getElementsByClassName("c-form__submit")[0].disabled = false;
    }, 600);
}

//element.closest polyfill. Remove when we move away from ie11
if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

var isDateSupported = function() {
    var input = document.createElement("input");
    var value = "a";
    input.setAttribute("type", "date");
    input.setAttribute("value", value);
    return input.value !== value;
};

//adding old browser fallback for date fields
if (!isDateSupported()) {
    var dates = document.querySelectorAll("input[type=date]");
    for (i = 0; i < dates.length; i++) {
        dates[i].type = "text";
        dates[i].name = "date_of_birth_reformat";
        dates[i].addEventListener("input", dob_mask, false);
    }
}

function dob_mask(e) {
    e.target.value = date_mask(e.target.value);
}

function date_mask(val) {
    return val
        .replace(/[^\d/]/g, "") //replace non digits and '\'
        .replace(/^(\d{2}\/\d{2})(\d)/, "$1/$2") //change 01/011 -> 01/01/1
        .replace(/^(\d{2})(\d)/, "$1/$2") //change 010 -> 01/0
        .replace(/(\/\d{4})\d+?$/, "$1"); //limit last set of numbers to 4 digits
}

//If country is UK remove inputs for phone number and preferred contact
function checkCountryOrigin(form) {
    var countryName = form.querySelector("select[name=country]");

    if (countryName?.value != "UK") {
        return;
    }

    if (!form.querySelector("input[name=requested_service_detail]")) {
        var requestedServiceDetail =
            '<input type="hidden" name="requested_service_detail" value="United Kingdom"></input>';
        var requestedService = form.querySelector(
            "input[name=requested_service]"
        );

        requestedService.insertAdjacentHTML("afterend", requestedServiceDetail);
    }

    var phoneNumber = form.querySelector("input[name=phone]"),
        preferredContact = form.querySelector("select[name=preferred_contact]");

    if (phoneNumber && preferredContact) {
        phoneNumber.parentNode.remove();
        preferredContact.parentNode.remove();
    }
}

function addErrorMessage(groupElement, inputElement, errorMessage) {
    if (groupElement && !groupElement.classList.contains("has-error")) {
        let errorSpan = document.createElement("span");
        errorSpan.className = "c-form__label c-form__label--error js-errorMessage";
        errorSpan.innerHTML = errorMessage;
        errorSpan.id = "error_" + inputElement.id;
        groupElement.classList.add("has-error");
        inputElement.parentElement.appendChild(errorSpan);
    }
}

function removeErrorMessage(groupElement) {
    groupElement?.classList.remove("has-error");
    groupElement?.querySelector(".js-errorMessage").remove();
}

//Email and phone validation (after submission)

function ajaxValidation(form) {
    form.classList.add("c-form--submitting");
    let emailInput = form.querySelector("input[name=email]");
    let phoneInput = form.querySelector("input[name=phone]");

    let emailGroup = emailInput?.closest(".js-formGroup");
    let phoneGroup = phoneInput?.closest(".js-formGroup");

    var emailValue =
        form.querySelector("input[name=email]") !== null
            ? form.querySelector("input[name=email]").value
            : "";
    var phoneValue =
        form.querySelector("input[name=phone]") !== null
            ? form.querySelector("input[name=phone]").value
            : "";

    var data = {
        email: emailValue,
        phone: phoneValue
    };

    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
        let validated = true;
        if (xhr.status >= 200 && xhr.status < 400) {
            var data = JSON.parse(xhr.responseText);

            if (emailValue && data.email === "undeliverable") {
                validated = false;
                addErrorMessage(emailGroup, emailInput, "Please provide a valid email address.");
            }
            
            if (data.email !== "undeliverable" && emailGroup?.classList.contains("has-error")) {
                removeErrorMessage(emailGroup);
            }

            if (phoneValue && data.phone === false) {
                validated = false;
                addErrorMessage(phoneGroup, phoneInput, "Please provide a valid phone number.");
            } 
            
            if (data.phone !== false && phoneGroup?.classList.contains("has-error")) {
                removeErrorMessage(phoneGroup);
            }
        }

        form.classList.remove("c-form--submitting");

        if (validated === true) {
            sendFormData(form);
        }
    };
    xhr.open("POST", "/wp-content/themes/asbestos/ajax/validation.php", true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(JSON.stringify(data));
}

});